import React from "react";
import Carousel from "react-bootstrap/Carousel";
import "bootstrap/dist/css/bootstrap.min.css";
import "./HomeBanner.css"
// Agar images src/assets/Banner/ me hain
import hbn1 from "../assets/Banner/vd-bn1.png";
import hbn2 from "../assets/Banner/vd-bn2.png";
import hbn3 from "../assets/Banner/vd-bn3.png";

const HomeBanner = () => {
  return (
    <div className="banner-slide">
    <Carousel slide interval={1500} pause={false} controls={false} indicators={true}>
      <Carousel.Item>
        <img  loading="lazy" className="d-block w-100 banner-img" src={hbn1} alt="Slide 1" />
      </Carousel.Item>

      <Carousel.Item>
        <img  loading="lazy" className="d-block w-100 banner-img" src={hbn2} alt="Slide 2" />
      </Carousel.Item>

      <Carousel.Item>
        <img  loading="lazy" className="d-block w-100 banner-img" src={hbn3} alt="Slide 3" />
      </Carousel.Item>
    </Carousel>
    </div>
  );
};

export default HomeBanner;
